import React, { Component } from 'react';
import Button from './Button';
import TableBlock from './Block';
import constants from './constants';

export default function createUploaderPlugin(options, setRefreshingState) {
  return {
    title: 'ProductManager',
    type: constants.PLUGIN_TYPE,
    buttonComponent: Wrapper(Button, options, setRefreshingState),
    blockComponent: Wrapper(TableBlock, options, setRefreshingState),
    options: {
      displayOptions: [],
      defaultDisplay: null,
      ...options,
    },
    ...options,
  };
}

const Wrapper = (WrappedComponent, options = {}, setRefreshingState) => {
  return class PropsProxy extends React.Component {
    render() {
      const props = Object.assign({}, this.props, {
        options,
        setRefreshingState,
      });
      return <WrappedComponent {...props} />;
    }
  };
};
